// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// Formularios
import CrearTienda from "components/Formularios/CrearTienda";

// views

export default function Tiendas() {
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        <CrearTienda /> 
        
        <div className="px-4 md:px-10 mx-auto w-full">
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
